import s from './notfound.module.scss';


export function NotFound() {
  return (
      <h1 className={s.NotFoundMsg}>404 NotFound</h1>
  )
}